import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';
import Parser from 'html-react-parser';
import JoditEditor from 'jodit-react';
import SvgIcon from 'react-icons-kit';
import { bin } from 'react-icons-kit/icomoon/bin';

const {htmlToText} = require('html-to-text');
var Config = require('../../../config');

class ModalNotes extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveNotes = this.saveNotes.bind(this);
		this.getNotes = this.getNotes.bind(this);
		this.setContent = this.setContent.bind(this);
		this.disableNote = this.disableNote.bind(this);
		this.showAllNotes = this.showAllNotes.bind(this);
		this.getDonationNotes = this.getDonationNotes.bind(this);
		
		this.state = {
		    show: false,
		    donation_notes_id:"",
		    notes:"",
		    donation_id:"",
		    options:[{key:"note",value:"Nota"},{key:"alert",value:"Alerta"}],
		    option:"",
		    samples_id:"",
			offers_id:"",
			donor_id:"",
		    menu:"",
		    saved_notes:[],
			saved_alert:[],
			config:{
				buttonsSM: ['bold', 'italic', 'underline', 'strikethrough', 'eraser', 'ul', 'ol', 'font', 'fontsize', 'indent', 'outdent'],
				readonly:false,
				language: "es",
				autofocus:true
			},
			all_notes:false
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false, menu:"", all_notes:false});
	}

	handleShow(donation_notes_id, donation_id, sample_id, offers_id, donor_id, menu) {
		this.setState({
			show: true, 
			donation_notes_id:donation_notes_id, 
			donation_id:donation_id,
			donor_id:donor_id,
		});

		if(sample_id !== undefined){
			this.setState({
				samples_id:sample_id
			});
		}
		if(offers_id !== undefined){
			this.setState({
				offers_id:offers_id
			});
		}
		if(menu !== undefined){
			this.setState({
				menu:menu
			});
		}

		if(menu === 'sample_register'){
			if(donation_notes_id !== 0 && donation_notes_id !== ''){
				fetch(Config.default.apiGateway.URL+'donation_notes/'+donation_notes_id, {
					method : 'get',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept' 		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				})
				.then(res => {
		            if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(error) {
		                swal('¡Error', error, 'error');
		              });
			        }
			    })
				.then(response =>{
					this.setState({notes:htmlToText(response.note), option: response.type.toLowerCase()});
				}) 
			}
		}else if(menu === 'donation_notes'){
			setTimeout(()=>{
				this.getDonationNotes(offers_id);
			}, 500)
			
		}else{
			this.getNotes(offers_id, menu);
		} 
			
	}

	getNotes(offers_id, menu, actives=true){
		this.props.waiting.handleShow('Cargando...');
		var url = 'donation_notes/by_offer?offers_id='+offers_id+'&actives='+actives;
		if(this.props.location.pathname.indexOf('results_donation') !== -1){
			url = 'donation_notes/laboratory?offers_id='+offers_id+'&actives='+actives;
		}

		fetch(Config.default.apiGateway.URL+url,{
			method:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'				: 'application/json',
				'Content-Type'	: 'application/json'
			})	
		}).then(res => {
			this.props.waiting.handleClose();

			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error',msg,'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				var notes = [];
				var alert = [];
				response.res.map((res)=>{
					var note = htmlToText(res.note.note);
					if(res.note.type.toUpperCase() !== 'ALERT'){
						var screen = '';

						if(res.note.proces_type === 'EXTRACION'){
							screen = 'EXTRACIÓN';
						}

						if(res.note.proces_type === 'CLINIC_HISTORY'){
							screen = 'HISTORIA CLINICA';
						}

						if(res.note.proces_type === 'REGISTER'){
							screen = 'REGISTRO';
						}

						if(res.note.proces_type === 'LABORATORY'){
							screen = 'LABORATORIO';
						}

						/*notes += ' -- '+screen+' -- \n'+
								 '** '+res.medical_staff+'\t'+
								 moment(res.note.timestamp).format('DD/MM/YYYY HH:mm')+'\n'+
								 note+'\n\n'*/

						notes.push({
							screen: screen,
							id: res.note.id,
							user_date: res.medical_staff+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
							note: note,
							active: res.note.active
						});
					}else{
						var screen = '';

						if(res.note.proces_type === 'EXTRACION'){
							screen = 'EXTRACIÓN';
						}

						if(res.note.proces_type === 'CLINIC_HISTORY'){
							screen = 'HISTORIA CLINICA';
						}

						if(res.note.proces_type === 'REGISTER'){
							screen = 'REGISTRO';
						}

						if(res.note.proces_type === 'LABORATORY'){
							screen = 'LABORATORIO';
						}

						alert.push({
							screen: screen,
							id: res.note.id,
							user_date: res.medical_staff+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
							note: note,
							active: res.note.active
						});
					}

				})

				this.setState({saved_alert:alert});
				this.setState({saved_notes:notes});
				
			}
		})
	}

	getDonationNotes(offers_id, actives=true){
		this.props.waiting.handleShow('Cargando...');

		var url = 'donation_notes/by_offer?offers_id='+offers_id+'&actives='+actives;
		if(this.props.location.pathname.indexOf('results_donation') !== -1){
			url = 'donation_notes/by_donor?donor_id='+this.state.donor_id+'&actives='+actives;
		}

		fetch(Config.default.apiGateway.URL+url,{
			method:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'				: 'application/json',
				'Content-Type'	: 'application/json'
			})	
		}).then(res => {
			this.props.waiting.handleClose();

			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error',msg,'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				var notes = [];
				var alert = [];
				response.res.map((res)=>{
					if(res.note.type !== 'ALERT'){
						var screen = '';

						if(res.note.proces_type === 'EXTRACION'){
							screen = 'EXTRACIÓN';
						}

						if(res.note.proces_type === 'CLINIC_HISTORY'){
							screen = 'HISTORIA CLINICA';
						}

						if(res.note.proces_type === 'REGISTER'){
							screen = 'REGISTRO';
						}

						if(res.note.proces_type === 'LABORATORY'){
							screen = 'LABORATORIO';
						}

						notes.push({
							screen: screen,
							id: res.note.id,
							user_date: res.medical_staff+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
							note: htmlToText(res.note.note),
							active: res.note.active
						});
					}else{
						var screen = '';

						if(res.note.proces_type === 'EXTRACION'){
							screen = 'EXTRACIÓN';
						}

						if(res.note.proces_type === 'CLINIC_HISTORY'){
							screen = 'HISTORIA CLINICA';
						}

						if(res.note.proces_type === 'REGISTER'){
							screen = 'REGISTRO';
						}

						if(res.note.proces_type === 'LABORATORY'){
							screen = 'LABORATORIO';
						}

						alert.push({
							screen: screen,
							id: res.note.id,
							user_date: res.medical_staff+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
							note: htmlToText(res.note.note),
							active: res.note.active
						});
					}


				})

				this.setState({saved_alert:alert});
				this.setState({saved_notes:notes, option:'note'});
				
			}
		})
	}

	disableNote(e, id){
		e.preventDefault();

		swal({
			title: '¿Desea eliminar la nota?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				fetch(Config.default.apiGateway.URL+'donation_notes/inactive/'+id,{
					method:'post',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						if(this.state.menu === 'donation_notes'){
							this.getDonationNotes(this.state.offers_id);
						}else{
							this.getNotes(this.state.offers_id, this.state.menu);
						} 
					}
				});
			}
		});
	}

	saveNotes(){
		var valid = this.state.option === 'alert' ? this.state.alerts : this.state.notes;
		var option = this.state.option === 'alert' ? 'alerta' : 'nota';

		if(valid.trim() === ""){
			swal('¡Atención!', "La "+option+" no puede estar vacia", 'warning');
		}else{
			var obj = {};
			var proces_type = '';
			switch(this.state.menu){
				case 'register':
					proces_type = 'REGISTER';
					break;
				case 'extraction':
					proces_type = 'EXTRACION';
					break;
				case 'sample_register':
					proces_type = 'MEDICAL_NOTE';
					break;
				default:
					proces_type = "LABORATORY";
					break;
			}


			obj = {
				proces_type:proces_type,
				type:this.state.option,
				note:this.state.option !== "alert" ? this.state.notes : this.state.alerts,
				donation_id: parseInt(this.state.donation_id,10) || null,
				offers_id: parseInt(this.state.offers_id, 10) || null,
				donor_id: this.state.donor_id
			}
			//lab_sections
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+'donation_notes', {
				method : 'post',
				body: JSON.stringify(obj), // data can be `string` or {object}!
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept' 		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				this.props.waiting.handleClose();
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(error) {
	                swal('¡Error', error, 'error');
	              });
		        }
		    })
			.then(response =>{
				if(response !== undefined){

					if(this.state.menu !== 'donor_search' && this.state.menu !== 'register' && this.state.menu !== 'extraction'){
						this.props.updateNotesID(response.id);
					}else if(this.state.menu !== 'register' && this.state.menu !== 'extraction'){
						this.props.setTable(this.props.donor_id);
					}
					
					this.setState({ show: false,notes:"", option:""});
				}
					
			});
		}
	}

	//Evento de cambio en elementos formulario
	handleChange = (event) => {
		if(event.target.value.length <= 500){
			if(event.target.name === 'notes'){
				if(this.state.option === 'alert'){
					this.setState({
						alerts: event.target.value,
						[event.target.name]: ''
					});

				}else{
					this.setState({
						[event.target.name]: event.target.value,
						alerts: '',
					});
				}
			}else{
				this.setState({
					[event.target.name]: event.target.value,
					alerts: "",
					notes:""
				});
			}	
		}
			
		
	}

	setContent(val){
		if(this.state.option === 'note'){
			this.setState({notes: val});
		}else if(this.state.option === 'alert'){
			this.setState({alerts: val});
		}else{
			this.setState({notes: "", alerts:""});
		}
	}

	showAllNotes(e){
		this.setState({all_notes: !this.state.all_notes});

		if(e.target.checked){
			if(this.state.menu === 'donation_notes'){
				this.getDonationNotes(this.state.offers_id, null);
			}else{
				this.getNotes(this.state.offers_id, this.state.menu, null);
			} 
		}else{
			if(this.state.menu === 'donation_notes'){
				this.getDonationNotes(this.state.offers_id);
			}else{
				this.getNotes(this.state.offers_id, this.state.menu);
			} 
		}
	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_notes.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
		        		{this.state.menu !== 'donation_notes' ? 
		        			<div className="form-group col-xs-12 col-sm-4">
					        	<span className="span-min">Tipo</span>
								<select className="form-control" name="option" id="option" value={this.state.option}
									onChange={this.handleChange}>
									<option value="">Seleccionar...</option>
					                {
					                this.state.options.map(function(t) {
					                	return <option  key={t.key}  value={t.key} >{t.value} </option>;
					                })
					            }
					            </select>
					        </div>
		        		:null}
		        		
				        {this.state.menu !== 'sample_register' &&        				
		        			<div className="col-xs-12 form-group">
			        			<div className="col-xs-12">
			        				<input type="checkbox" name="all_notes" id="all_notes" value={this.state.all_notes}
			        					checked={this.state.all_notes} onChange={(e)=>this.showAllNotes(e)} /> <span className="span-min">Ver todos</span>
			        			</div>
			        			<div className="col-xs-12">									
									<table className="table">
										<tbody style={{display:'block', height:'200px', overflowY:'auto'}}>
										{this.state.option === 'note' ?
											this.state.saved_notes.map((note, i)=>
												<tr key={i} style={{width:'100%', display:'grid'}}>
													<td>
														<div className="col-xs-11">
															<div className="col-xs-12" style={{textAlign:'right'}}>
																{note.user_date}
															</div>
															<div className="col-xs-12">
																<div>{note.screen}</div>
																<div>{note.note}</div>	
															</div>
														</div>
														<div className="col-xs-1">
															{note.active &&
																<button className="btn btn-info btn-xs" onClick={(e)=>this.disableNote(e, note.id)}>
																	<SvgIcon icon={bin}/>
																</button>
															}															
														</div>

													</td>
												</tr>
											)
										: this.state.option === 'alert' ?
											this.state.saved_alert.map((note, i)=>
												<tr key={i} style={{width:'100%', display:'grid'}}>
													<td>
														<div className="col-xs-11">
															<div className="col-xs-12" style={{textAlign:'right'}}>
																{note.user_date}
															</div>
															<div className="col-xs-12">
																<div>{note.screen}</div>
																<div>{note.note}</div>	
															</div>
														</div>
														<div className="col-xs-1">
															{note.active &&
																<button className="btn btn-info btn-xs" onClick={(e)=>this.disableNote(e, note.id)}>
																	<SvgIcon icon={bin}/>
																</button>
															}															
														</div>

													</td>
												</tr>
											)
										: null
										}
										</tbody>
									</table>
								</div>

		        			</div>}

						{this.state.menu !== 'donation_notes' ? 
							<div className="col-xs-12">
								<JoditEditor
									ref={ref => this.editor = ref}
									value={this.state.option === 'alert' ? this.state.alerts : this.state.notes}
									config={this.state.config}
									tabIndex={1}
									onChange={newContent => this.setContent(newContent)}
								/>
							</div>
		        		:null}
						{/*<textarea className="form-control" style={{height:"200px",width:"100%",resize:"none"}} name="notes" 
								value={this.state.option === 'alert' ? this.state.alerts : this.state.notes } id="notes" 
							onChange={ this.handleChange }/>*/}
							
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	{this.state.menu !== 'donation_notes' ? <FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveNotes}/> : null}
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalNotes);